<template>

    <div class="cmp-licencing-licence-sidewindow-licence_setup dt-page">

        <TextField2
          
            id="licence_account_name"
            :placeholder="$t('account_name')"
            :label="$t('account_name')"
            :value="selectedLicenceDetails.licence.licence_account_name"
            :disabled="true"
           
            @blur=" e => onTextFieldValueChange(e)"
        />
        <Checkbox2
          :disabled="false"
          :id="'active_flag'"
          :label="$dft.capHead('active')"
          :value="selectedLicenceDetails.licence.active_flag"
          :placeholder="$t('active')"
          @input="onCheckboxChange"
        />
        <TextField2
          
            id="licence_name"
            class="m1"
            :placeholder="$dft.capHead($t('licence_name'))"
            :label="$dft.capHead($t('licence_name'))"
            :value="selectedLicenceDetails.licence.licence_name"
           
            @blur=" e => onTextFieldValueChange(e) "
        />

        <TextField2
          
            id="licence_usage"
            class="m1"
            :placeholder="$dft.capHead('usage')"
            :label="$dft.capHead('usage')"
            :value="selectedLicenceDetails.licence.licence_usage"
           
            @blur=" e => onTextFieldValueChange(e) "
        />

        <Dropdown2

          id="licence_label_status_id"
          :label="$t('licence_type')"
          :placeholder="'Select ' + $t('licence_type')"
          :disabled="false"
          :options="licenceTypeTV"
          :selected="licenceTypeTV.find(e=>e.value==selectedLicenceDetails.licence.licence_label_status_id )"
          v-on:selectedChange="e => onDropdownChange('licence_label_status_id', e)"
        />

        <Dropdown2

          id="exclusivity"
          :label="$dft.capHead('exclusivity')"
          :placeholder="'Select ' + $dft.capHead('exclusivity')"
          :disabled="false"
          :options="exclusivityTV"
          :selected="exclusivityTV.find(e=>e.value==selectedLicenceDetails.licence.exclusivity)"
          v-on:selectedChange="e => onDropdownChange('exclusivity', e)"
        />
        <Dropdown2

          id="territory_id"
          :label="$t('territory')"
          :placeholder="'Select ' + $t('territory')"
          :disabled="false"
           :bb="'0px'"
          :options="territoryIdTV"
          :selected="territoryIdTV.find(e=>e.value==selectedLicenceDetails.licence.territory_id)"
          v-on:selectedChange="e => onDropdownChange('territory_id', e)"
        />
   
    </div> 
</template>
<script>

import {
  createTV,
  tv,
} from "../../../../models/text-value.model";



export default {
  props: {

    selectedLicenceDetails:{
      type:Object
    },
    releaseTypes:{
      type:Array
    }

  },

  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      licence_account_name:'',
      licence_name:'',
   
      licence_usage:'',
      licence_label_status_id:'',
      territory_id:'',
    };
  },
  methods:{
    onCheckboxChange: function ({ name, value }) {
      console.log("WWWWWWqqqqqqqqqqqq",name, value);
      this.$emit("changed", {
        name,
        value: value ? "1" : "0",
      });
    },
    onTextFieldValueChange:function (e ) {
      const payload={ 
                      name:e.name ,
                      value:e.value,
                    
                    }
      this.$emit('changed',payload)
      console.log("WERERTYUPOIUN",payload)
    },
    onDropdownChange:function(name,e){
      const payload={
                      name:name ,
                      value:e.value,
                    }
      this.$emit('changed',payload)
      console.log("WERERTYUPOIUN",payload)
    },


  },
  computed:{
  
    licenceTypeTV:function(){
     
      return createTV(this.selectedLicenceDetails.licence_statuses,"label_status_name","label_status_id");
        // [
        //   {text:"compilation",value:"compilation"},
        //   {text:"exclusive licence",value:"exclusive_licence"},
        //   {text:"sync movie",value:"sync_movie"},
        //   {text:"sync advertisement",value:"sync_advertisement"},
        //   {text:"promotion",value:"promotion"},
        //   {text:"covermount CD",value:"covermount_cd"},
        // ];
      
    },
    exclusivityTV: function(){
  
      return[
          {text:"exclusive",value:"exclusive"},
          {text:"non exclusive",value:"non_exclusive"}
        ]
        
    },
    territoryIdTV:function(){
        console.log(this.selectedLicenceDetails,":::::::::::::::")
        return createTV(this.selectedLicenceDetails.territories,"territory_name","territory_id");
    },
  }

}
</script>
<style lang="scss">
.cmp-licencing-licence-sidewindow-licence_setup{
  
  .flex-container {
    display:flex;
    padding: 10px;
    .flex-item{
      flex:0.25;
      padding:10px
    }
  }

}
</style>
